export class formfnsimplerectificatif {
  constructor() {}
  commonStep = 'stepper.form.commun.SIMP.step'
  step = 'stepper.form.simp_re.step';
  step4 = 'stepper.form.simp_re.step4';
  step9 = 'stepper.form.simp_re.step9';
  step10 = 'stepper.form.simp_re.step10';
  step14 = 'stepper.form.simp_re.step14';
}
